import * as authStore from '../../auth-store'

export const userIdentification = () => {
  authStore.subscribe(auth => {
    if (!auth) { return }

    const { claims = {} } = auth

    window.gtag?.('set', 'user_id', claims.sub)
    window.gtag?.('event', 'set_organization', {
      organization: claims.org,
    })
  })
}
